import { z } from "zod";

import { monthlyAuditDate } from "@/schemas";

import {
  environmentalChecklistItem,
  environmentalChecklistItemWithTicket,
} from "../../../../schemas";

export const dayEnvChecklistRefrigeratorSchema = z.object({
  auditDate: monthlyAuditDate,
  locationId: z.string().min(1, "Required"),
  reviewerId: z.string().min(1, "Required"),
  refrigeratorTempLog: environmentalChecklistItem,
  refrigeratorUnder: environmentalChecklistItem,
  refrigeratorTop: environmentalChecklistItem,
  refrigeratorRepair: environmentalChecklistItemWithTicket,
  refrigeratorComment: z.string().optional(),
});
